import type { IFilterValue } from 'entities/Contacts/api/filterTypes.ts'
import { type FilterItem } from 'widgets/FilterEditor/model'

export const EmptyOperators = new Set(['is_known', 'is_unknown', 'last_week', 'last_month'])

export const isEmptyWidget = <T extends IFilterValue, C>(filterItem: FilterItem<T, C>) =>
  !!filterItem.operator && EmptyOperators.has(filterItem.operator.key)
